import { render, staticRenderFns } from "./inputs-header.vue?vue&type=template&id=6a2186e6&scoped=true&"
import script from "./inputs-header.vue?vue&type=script&lang=ts&"
export * from "./inputs-header.vue?vue&type=script&lang=ts&"
import style0 from "./inputs-header.vue?vue&type=style&index=0&id=6a2186e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2186e6",
  null
  
)

export default component.exports